import MuiTabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import type { ReactNode } from "react";

export interface TabItem {
  value: string;
  label: ReactNode;
}

export interface TabsProps {
  value: string;
  onChange: (value: string) => void;
  items: TabItem[];
}

/** Presentational tab bar. Rendering the active tab's content is the caller's job. */
export function Tabs({ value, onChange, items }: TabsProps) {
  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <MuiTabs value={value} onChange={(_event, next: string) => onChange(next)}>
        {items.map((item) => (
          <Tab key={item.value} value={item.value} label={item.label} />
        ))}
      </MuiTabs>
    </Box>
  );
}
